import { render } from "./ImportMatch.vue?vue&type=template&id=951725e0"
import script from "./ImportMatch.vue?vue&type=script&lang=js"
export * from "./ImportMatch.vue?vue&type=script&lang=js"

import "./ImportMatch.vue?vue&type=style&index=0&id=951725e0&lang=scss"

import exportComponent from "/app/tmp/origina/V3/v2026.12.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__